export class profileFormQuestion {
    static age: string = 'Wann wurdest du geboren?';
    static hobby: string = 'Was sind deine Hobbies?';
    static project: string = 'In welchem Projekt arbeitest du derzeit?';
    static gender: string = 'Was ist deine geschlechtliche Identität?';
    static country: string = 'Was ist deine ethnische Herkunft?';
    static language: string = 'Was ist deine Muttersprache?';
    static religion: string = 'An welche Religion glaubst du?';
    static workExperience: string = 'Wie viele Jahre Berufserfahrung hast du schon gesammelt?';
    static education: string = 'Welchen Bildungsweg hast du bisher bestritten?';
    static diet: string = 'Wie ernährst du dich?';
    static sexualOrientation: string = 'Was ist deine sexuelle Orientierung?';
    // eslint-disable-next-line max-len
    static socialBackground: string = 'Bist du ein Akademikerkind, oder eher die erste Person in der Familie, die studiert oder ihr Abitur gemacht hat?';
    // eslint-disable-next-line max-len
    static socialBackgroundDiscrimination: string = 'Wurdest du jemals aufgrund deiner sozialen Herkunft Vorurteilen ausgesetzt, herabwürdigend behandelt, benachteiligt oder ausgeschlossen?';
}
